/**
 * Foundation.Google namespace.
 */

// Google SignIn JS documentation
// https://developers.google.com/identity/sign-in/web/reference

Foundation.Google = {}

Foundation.Google.loadGoogleOauth = function (options) {
  var result = new Foundation.Promise()
  if (window.gapi !== undefined) {
    result.fulfill()
  }
  else {
    var googApiJS = "https://apis.google.com/js/platform.js"
    options = Foundation.extend({
        "clientId": jQuery('meta[name="google-signin-client_id"]').attr("content")
    }, options)
    var script = new Foundation.Script(googApiJS, true)
    script.then(function () {
      gapi.load('auth2', function () {
        gapi.auth2.init(options).then(function () {
          // if(window.console) console.log('gapi.auth2 intialized.')
          // Make sure listeners aren't duplicated
          if (!window["Foundation"]["Google"]["loginListenersSet"]) {
            this.auth().isSignedIn.listen(this.userSignInListener)
            this.auth().currentUser.listen(this.userChangeListener)
            window["Foundation"]["Google"]["loginListenersSet"] = true
          }
          result.fulfillWith(this)
        }.bind(this), function () {
          // if(window.console) console.log('gapi.auth2 failed to init. client_id: '+options.clientId)
          result.failWith(this)
        })
      }.bind(this))
    }.bind(this))
  }
  return result
}

Foundation.Google.cleanCookie = function () {
  return new Foundation.API("DELETE", "Google/Member")
}

Foundation.Google.userSiteSignOut = function () {
  // Google SignOut
  if (this.authSignedIn()) this.authSignOut()
  // Foundation logout
  var sessionManager = Foundation.Session.Manager.sharedInstance()
  if (sessionManager.isAuthenticated()) sessionManager.logOut()
}

Foundation.Google.userSiteSignIn = function () {
  if (this.userSignedIn()) {
    var sessionManager = Foundation.Session.Manager.sharedInstance()
    if (sessionManager.isAuthenticated()) return
    var authenticator = new Foundation.Google.Authenticator()
    authenticator.authenticateWithFoundation().then(function () {
      var member = new Foundation.Member(authenticator.memberOid())
      member.set("userName", authenticator.memberUserName())
      member.set("avatarUrl", authenticator.memberAvatarUrl())
      sessionManager.logIn(authenticator.sessionManagerDelegateID(), member)
    }.bind(this))
  }
}

Foundation.Google.userSignInListener = function (val) {
  // if(window.console) console.log('Signin state changed to ', val)
  if (window.Foundation.Google.signInListening) {
    if (val === false) {
      Foundation.Google.userSiteSignOut()
    }
    else {
      Foundation.Google.userSiteSignIn()
    }
  }
}

Foundation.Google.userChangeListener = function ( /* user */ ) {
  // if(window.console) console.log("Current User Change called. ")
  // Nothing to do here
}

Foundation.Google.auth = function () {
  return gapi.auth2.getAuthInstance() || null
}

Foundation.Google.authSignIn = function () {
  // .signIn returns a promise
  return this.auth().signIn() || null
}

Foundation.Google.authSignOut = function () {
  return this.auth().signOut() || null
}

Foundation.Google.authSignedIn = function () {
  return this.auth().isSignedIn.get() || null
}

Foundation.Google.user = function () {
  return this.auth().currentUser.get() || null
}

Foundation.Google.userSignedIn = function () {
  return this.user().isSignedIn() || null
}

Foundation.Google.googleIdToken = function () {
  return this.user().getAuthResponse().id_token || null
}

Foundation.Google.userEmailAddress = function () {
  return this.user().getBasicProfile().getEmail() || null
}

Foundation.Google.userName = function () {
  return this.user().getBasicProfile().getName() || null
}

Foundation.Google.disconnectFromFoundation = function () {
  return this.auth().disconnect() || null
}

// ---------------------------------------------------------------------

window["Foundation"]["Google"]["loadGoogleOauth"] = Foundation.Google.loadGoogleOauth

// ---------------------------------------------------------------------
